// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1tr8p","savePackageButton":"ClientWallet_savePackageButton__1vuag"};